import { Component, EventEmitter, Inject, Input, Output } from '@angular/core'
import { Customer, CustomerPreferenceInterface } from 'src/app/models/customer'
import { ToastService } from 'src/app/services/toast.service'
import { CustomerService } from "../../services/customer.service";

@Component({
    selector: 'gea-shop-customer-preferences',
    templateUrl: './preferences.component.html',
    styleUrls: ['./preferences.component.scss'],
    standalone: false
})
export class PreferencesComponent {

  @Input() customer: Customer | undefined
  @Input() submitBtnText: string = "Speichern"

  @Output("applyPreferences") applyPreferencesEvent = new EventEmitter()

  availablePreferences: CustomerPreferenceInterface[] = []

  constructor(
    @Inject(ToastService) private toastService: ToastService,
    @Inject(CustomerService) private customerService: CustomerService
  ) {
    this.customerService.getAvailablePreferences().subscribe(preferences => {
      if (preferences) this.availablePreferences = preferences
    })
  }

  isActive(value: string, preferenceShort: string): boolean {
    if (! this.customer?.preferences) {
      return false
    }

    for (let preference of this.customer.preferences) {
      const pref = (preference as any)[1]

      if (preferenceShort != pref.preferenceShort) {
        continue
      }
      if (pref.values.includes(value)) {
        return true
      }
    }
    return false
  }

  togglePreference(preference: CustomerPreferenceInterface, value: string) {
    if (! this.customer?.preferences) return
    const isSet = this.isActive(value, preference.preferenceShort)
    let found = false

    for (let [ , entry] of this.customer?.preferences) {
      if (entry.preferenceShort == preference.preferenceShort) {
        found = true
        if (isSet) { // remove if set
          entry.values = entry.values.filter((evalue) => {
            return value != evalue
          })
        } else {  // add if not set
          entry.values.push(value)
        }
        this.customer.preferences.set(preference.preferenceId, entry)
      }
    }

    if (! found) {
      let entry = JSON.parse(JSON.stringify(preference))
      entry.values = [value]
      this.customer.preferences.set(preference.preferenceId, entry)
    }
  }

  saveCustomerPreferences() {
    if (! this.customer?.preferences) {
      return
    }

    this.customerService.savePreferences(this.customer.preferences).subscribe(response => {
      this.toastService.showSuccess("Erfolgreich gespeichert")
      this.applyPreferencesEvent.emit()
    })
  }
}
